module.exports = __webpack_public_path__ + "img/logo-shop@2x.b2674e59.png";